<div class="card border-0">
  <ng-container *ngIf="!!notification.messageLanguage">
    <div class="row">
      <div class="col-2">
        <img src="{{ notification.image | contentImage: '1' }}" />
      </div>
      <div class="col-10 font-size-10">
        <div class="notification-message mt-1">
          {{ notification.messageLanguage?.message }}
        </div>
        <div class="d-flex justify-content-between">
          <div class="text-muted"><fgbcl-time-since [startDate]="notification.messageDate"></fgbcl-time-since></div>
          <!-- Notification Link -->
          <ng-container [ngSwitch]="notification.actionType">
            <a class="font-weight-bold" *ngSwitchCase="actionType.InternalLink" [routerLink]="notification.linkUrl"
              >{{ notification.messageLanguage?.linkText }}></a
            >

            <a
              class="font-weight-bold"
              *ngSwitchCase="actionType.ExternalLink"
              [href]="notification.linkUrl"
              target="_blank"
              rel="noopener"
            >
              {{ notification.messageLanguage?.linkText }}>
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</div>
